var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101px",
    height: "65px",
    viewBox: "0 0 101 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "np_ticket_3257523_000000 copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8-Insert-Card",
    transform: "translate(-222.000000, -1278.000000)",
    fill: "#6236FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(221.500000, 832.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_ticket_3257523_000000-copy",
    transform: "translate(51.000000, 478.500000) rotate(90.000000) translate(-51.000000, -478.500000) translate(18.000000, 428.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.272344,0.5 L45.3361946,0.5 C43.0035854,0.5 41.1085386,2.37256 41.1085386,4.68659661 C41.1044103,9.11444585 37.4753967,12.7041385 33,12.7041385 C28.5246033,12.7041385 24.8955834,9.11444585 24.8914614,4.68659661 C24.8914614,2.37256 22.9964146,0.5 20.6638054,0.5 L4.72765602,0.5 C2.39504681,0.5 0.5,2.37256 0.5,4.68659661 L0.5,96.3134034 C0.5,98.6233581 2.39504681,100.495918 4.72765602,100.5 L20.6638054,100.5 C22.9964146,100.495911 24.8914614,98.6233581 24.8914614,96.3134034 C24.8873331,94.1791811 25.7419496,92.1349706 27.261274,90.6263306 C28.7847099,89.1176905 30.8489686,88.27137 33,88.27137 C35.1510314,88.27137 37.2152901,89.11768 38.738726,90.6263306 C40.2580399,92.1349706 41.1126605,94.1791811 41.1085386,96.3134034 C41.1085386,98.6233581 43.0035854,100.495918 45.3361946,100.5 L61.272344,100.5 C63.6049532,100.495911 65.5,98.6233581 65.5,96.3134034 L65.5,4.68659661 C65.5,2.37256 63.6049532,0.5 61.272344,0.5 Z M57.044688,28.6653287 L51.2316609,28.6612405 L51.2316609,37.0344337 L57.040566,37.0344337 L57.0446943,92.1227186 L49.0187007,92.1227186 C47.7636153,87.4209612 44.469003,83.5123546 40.0184438,81.4521305 C35.5720066,79.3914876 30.4277947,79.3914876 25.9815689,81.4521305 C21.5310097,83.5127733 18.2363974,87.4212752 16.981312,92.1227186 L8.95531839,92.1227186 L8.95531839,37.0344337 L15.717877,37.0344337 L15.717877,28.6612405 L8.95531839,28.6612405 L8.95531839,8.87329161 L16.981312,8.87329161 C18.2363974,13.5750489 21.5310097,17.4836555 25.9815689,19.5438797 C30.4280061,21.6045226 35.572218,21.6045226 40.0184438,19.5438797 C44.469003,17.4832369 47.7636153,13.5747349 49.0187007,8.87329161 L57.0446943,8.87329161 L57.044688,28.6653287 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "27.5 28.5 39.5 28.5 39.5 37.5 27.5 37.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "18.5 46.5 48.5 46.5 48.5 55.5 18.5 55.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "18.5 64.5 48.5 64.5 48.5 73.5 18.5 73.5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.66df2bcc85e82e8608d800ede969f894.svg";
export { ForwardRef as ReactComponent };